// import React, { useEffect, useState } from 'react';
// import PropertyFilter from '../Filterpages/FilterComponent';
// import Filterpageproperty from '../Filterpages/FilterpageView';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import { API_BASE_URL } from '../../utils';
// import { Col, Row } from 'react-bootstrap';
// import EnquiryFormModal from '../Enquiry/Enquiry';
// import "./Sub.css";
// function IndividualVilla({ categoryId }) {

//   const [data, setProperties] = useState([]);
//   const [expandedDescriptions, setExpandedDescriptions] = useState({});
//   const [modalShow, setModalShow] = React.useState(false);
//   // Fetch properties for the selected category
//   useEffect(() => {
//     axios.get(`${API_BASE_URL}/property/getproperty`, {
//       params: {
//         propertyType: 'Individual Villa'
//       }
//     })
//       .then((response) => {
//         console.log(response.data.data.properties
//         )
//         setProperties(response.data.data.properties
//         ); // Assuming response.data is an array of properties
//       })
//       .catch((error) => {
//         console.error('Error fetching properties:', error);
//       });
//   }, []);
//   const toggleDescription = (index) => {
//     setExpandedDescriptions(prevState => ({
//       ...prevState,
//       [index]: !prevState[index]
//     }));
//   };
//   const formatPrice = (price) => {
//     if (price >= 10000000) {
//       return (price / 10000000).toFixed(2) + ' Cr';
//     } else if (price >= 100000) {
//       return (price / 100000).toFixed(2) + ' L';
//     } else {
//       return price.toString();
//     }
//   };
//   return (
//     <>
//       <div className='container'>
//         <Row>
//           <Col md={12} className='filter-col'>
//             <Filterpageproperty />
//           </Col>
//         </Row>
//         <Row>
//           <Col>
//         <nav className='ms-3'>
//           <ol class="breadcrumb  w-50 mt-4">
//             <li class="breadcrumb-item "><Link to={"/"} className='text-decoration-none text-black '>Chennai Auction Property</Link></li>
//             <li class="breadcrumb-item active">Individual Villas</li>
//           </ol>
//         </nav>
//           </Col>
//         </Row>

//         <div className='row'>
//           <div className='col-md-8'>
//             {/* <h5 className='bg-white w-50 p-3  sha border border-0'>
//           Individual Villas for sale in Chennai
//             </h5> */}
//             <div className="scrollable-container">
//               {data.map((property, index) => (
//                 <div className="card-container1 mt-5 mb-5" key={index}>
//                   <div className="card-header1">
//                     <img src={property.propertyImages[0].propertyImage} alt="card-image" className="card-image1 " />
//                   </div>
//                   <div className="card-body1 m-2">
//                     <h4 className="card-subtitle1 ">{property.propertyTitle}</h4>
//                     <h6 className="card-title1">
//                       <span className='fw-bold text-capitalize fs-6'></span><i class="fa-solid fa-location-dot"></i> {property.address}
//                     </h6>


//                     <table className="table table-striped-columns border border-2  ">


//                       <tr className=' bg-color-2   '>
//                         <th className='p-2 text-center fw-medium '> Type</th>
//                         <th className='p-2  text-center fw-medium  '>Property Type</th>
//                         <th className='p-2  text-center fw-medium '>Price</th>
//                         <th className='p-2 text-center fw-medium '>Sqft</th>
//                       </tr>
//                       <tr className='bg-color-1'>
//                         <td className='p-2 text-center fw-light'>{property.type}</td>
//                         <td className='p-2 text-center  fw-light '>{property.propertyType}</td>
//                         <td className='p-2 text-center fw-light'>  {formatPrice(property.price)}</td>
//                         <td className='p-2 text-center fw-light '>{property.totalArea}</td>
//                       </tr>
//                     </table>
//                     <div>

//                     </div>


//                     <div key={index} className={`card-text1 ${expandedDescriptions[index] ? 'expanded' : 'collapsed'}`} onClick={() => toggleDescription(index)} style={{ cursor: 'pointer' }}>
//                       <span className='fw-bold text-capitalize'>{property.title}</span>
//                       <div dangerouslySetInnerHTML={{ __html: expandedDescriptions[index] ? property.propertyDescription : `${property.propertyDescription.slice(0, 100)}...` }} />
//                       <span style={{ color: 'blue', marginLeft: '0px' }} className='fw-bold text-black'>
//                         {expandedDescriptions[index] ? 'Show Less' : 'Show More'}
//                       </span>
//                     </div>

//                     <div className='d-flex '>
//                       <Link to={`/viewalldetails/${property._id}`} className='ms-auto '>

//                         <button className='btn btn-warning opacity-75  fw-bold text-white'>More Details</button>
//                       </Link>



//                       <button className='btn  btn-outline-dark ms-2 fw-bold' onClick={() => setModalShow(true)} >Enquiry</button>

//                       <EnquiryFormModal show={modalShow}
//                         onHide={() => setModalShow(false)} />

//                       {/* <button className='btn btn-info'>Owner Details</button> */}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className='col'>
//             <PropertyFilter />
//           </div>
//         </div>
//       </div>


//     </>
//   );
// }

// export default IndividualVilla;
// Make sure React is imported only once at the beginning of the file
// import React, { useEffect, useState, useRef } from 'react';
// import PropertyFilter from '../Filterpages/FilterComponent';
// import Filterpageproperty from '../Filterpages/FilterpageView';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import { API_BASE_URL } from '../../utils';
// import { Col, Row } from 'react-bootstrap';
// import EnquiryFormModal from '../Enquiry/Enquiry';
// import "./Sub.css";
// import axiosInstance from '../../utils/429Error';

// function IndividualVilla({ categoryId }) {
//   const [data, setProperties] = useState([]);
//   const [expandedDescriptions, setExpandedDescriptions] = useState({});
//   const [modalShow, setModalShow] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [propertiesPerPage] = useState(6); // Adjust as needed
//   const scrollRef = useRef(null);

//   useEffect(() => {
//     axiosInstance.get(`${API_BASE_URL}/property/getproperty`, {
//       params: {
//         propertyType: 'Individual Villa'
//       }
//     })
//       .then((response) => {
//         setProperties(response.data.data.properties);
//       })
//       .catch((error) => {
//         console.error('Error fetching properties:', error);
//       });
//   }, [categoryId]);

//   useEffect(() => {
//     // Scroll a bit higher than the top of the component when it mounts
//     if (scrollRef.current) {
//       scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
//       window.scrollBy(0, -800); // Scroll up by 600 pixels
//     }
//   }, []);

//   const toggleDescription = (index) => {
//     setExpandedDescriptions(prevState => ({
//       ...prevState,
//       [index]: !prevState[index]
//     }));
//   };

//   const formatPrice = (price) => {
//     if (price >= 10000000) {
//       return (price / 10000000).toFixed(2) + ' Cr';
//     } else if (price >= 100000) {
//       return (price / 100000).toFixed(2) + ' L';
//     } else {
//       return price.toString();
//     }
//   };

//   // Pagination logic
//   const indexOfLastProperty = currentPage * propertiesPerPage;
//   const indexOfFirstProperty = indexOfLastProperty - propertiesPerPage;
//   const currentProperties = data.slice(indexOfFirstProperty, indexOfLastProperty);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   const nextPage = () => setCurrentPage(prevPage => Math.min(prevPage + 1, Math.ceil(data.length / propertiesPerPage)));
//   const prevPage = () => setCurrentPage(prevPage => Math.max(prevPage - 1, 1));


//   return (
//     <div className='container' ref={scrollRef}>
//       <Row>
//         <Col md={12} className='filter-col'>
//           <Filterpageproperty />
//         </Col>
//       </Row>
//       <Row>
//         <Col>
//           <nav className='ms-3'>
//             <ol className="breadcrumb  w-50 ">
//               <li className="breadcrumb-item "><Link to={"/"} className='text-decoration-none text-black'>Chennai Auction Property</Link></li>
//               <li className="breadcrumb-item active">IndividualVilla</li>
//             </ol>
//           </nav>
//         </Col>
//       </Row>
//       <div className='row'>
//         <div className='col-md-8'>
//           <div className="scrollable-container">
//             {currentProperties.map((property, index) => (
//               <div className="card-container1 mt-5 mb-5" key={index}>
//                 <div className="card-header1">
//                   <img src={property.propertyImages[0].propertyImage} alt="card-image" className="card-image1" />
//                 </div>
//                 <div className="card-body1 m-2">
//                   <h4 className="card-subtitle1">{property.propertyTitle}</h4>
//                   <h6 className="card-title1">
//                     <span className=' text-capitalize fs-6' style={{fontSize: "12px", fontWeight:"200px"}}><i className="fa-solid fa-location-dot"></i> {property.address}</span>
//                   </h6>
//                   <table className="table table-striped-columns border border-2">
//                     <thead>
//                       <tr className='bg-color-2'>
//                         <th className='p-2 text-center fw-medium'>Type</th>
//                         <th className='p-2 text-center fw-medium'>Property Type</th>
//                         <th className='p-2 text-center fw-medium'>Price</th>
//                         <th className='p-2 text-center fw-medium'>Sqft</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       <tr className='bg-color-1'>
//                         <td className='p-2 text-center fw-light'>{property.type}</td>
//                         <td className='p-2 text-center fw-light'>{property.propertyType}</td>
//                         <td className='p-2 text-center fw-light'>{formatPrice(property.price)}</td>
//                         <td className='p-2 text-center fw-light'>{property.totalArea}</td>
//                       </tr>
//                     </tbody>
//                   </table>
//                   <div className={`card-text1 ${expandedDescriptions[index] ? 'expanded' : 'collapsed'}`} onClick={() => toggleDescription(index)} style={{ cursor: 'pointer' }}>
//                     <span className='fw-bold text-capitalize'>{property.title}</span>
//                     <div dangerouslySetInnerHTML={{ __html: expandedDescriptions[index] ? property.propertyDescription : `${property.propertyDescription.slice(0, 100)}...` }} />
//                     <span style={{ color: 'blue', marginLeft: '0px' }} className='fw-bold text-black'>
//                       {expandedDescriptions[index] ? 'Show Less' : 'Show More'}
//                     </span>
//                   </div>
//                   <div className='d-flex'>
//                     <Link to={`/viewalldetails/${property._id}`} className='ms-auto'>
//                       <button className='btn btn-warning opacity-75 fw-bold text-white'>More Details</button>
//                     </Link>
//                     <button className='btn btn-outline-dark ms-2 fw-bold' onClick={() => setModalShow(true)}>Enquiry</button>
//                     <EnquiryFormModal show={modalShow} onHide={() => setModalShow(false)} />
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//           {/* Pagination controls */}
//           <div className="d-flex justify-content-center mt-4">
//             <nav>
//               <ul className="pagination">
//                 <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                   <button onClick={prevPage} className="page-link">Previous</button>
//                 </li>
//                 {[...Array(Math.ceil(data.length / propertiesPerPage)).keys()].map((number) => (
//                   <li key={number} className={`page-item ${currentPage === number + 1 ? 'active' : ''}`}>
//                     <button onClick={() => paginate(number + 1)} className="page-link">
//                       {number + 1}
//                     </button>
//                   </li>
//                 ))}
//                 <li className={`page-item ${currentPage === Math.ceil(data.length / propertiesPerPage) ? 'disabled' : ''}`}>
//                   <button onClick={nextPage} className="page-link">Next</button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </div>
//         <div className='col'>
//           <PropertyFilter />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default IndividualVilla;
import React, { useEffect, useState, useRef } from 'react';
import PropertyFilter from '../Filterpages/FilterComponent';
import Filterpageproperty from '../Filterpages/FilterpageView';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../utils';
import { Col, Row } from 'react-bootstrap';
import EnquiryFormModal from '../Enquiry/Enquiry';
import "./Sub.css";

const ITEMS_PER_PAGE = 3; // Set to 3 items per page

function IndividualVilla({ categoryId }) {
  // const [data, setProperties] = useState([]);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [viewType, setViewType] = useState('grid'); // 'grid' or 'list'
  const [filteredProperties, setFilteredProperties] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/property/getproperty`, {
      params: {
        propertyType: 'Individual Villa'
      }
    })
      .then((response) => {
        // setProperties(response.data.data.properties);
        setFilteredProperties(response.data.data.properties);
      })
      .catch((error) => {
        console.error('Error fetching properties:', error);
      });
  }, [categoryId]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      window.scrollBy(0, -800); 
    }
  }, []);

  const toggleDescription = (index) => {
    setExpandedDescriptions(prevState => ({
      ...prevState,
      [index]: !prevState[index]
    }));
  };

  const formatPrice = (price) => {
    if (price >= 10000000) {
      return (price / 10000000).toFixed(2) + ' Cr';
    } else if (price >= 100000) {
      return (price / 100000).toFixed(2) + ' L';
    } else {
      return price.toString();
    }
  };

  const indexOfLastProperty = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstProperty = indexOfLastProperty - ITEMS_PER_PAGE;
  const currentProperties = filteredProperties.slice(indexOfFirstProperty, indexOfLastProperty);
  const totalPages = Math.ceil(filteredProperties.length / ITEMS_PER_PAGE);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () => setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  const prevPage = () => setCurrentPage(prevPage => Math.max(prevPage - 1, 1));

  const toggleViewType = () => {
    setViewType(prevType => prevType === 'grid' ? 'list' : 'grid');
  };

  const handleFilter = (filteredData) => {
    setFilteredProperties(filteredData);
    setCurrentPage(1); // Reset to first page on filter change
  };

  return (
    <div className='container' ref={scrollRef}>
      <Row>
        <Col md={12} className='filter-col'>
          <Filterpageproperty />
        </Col>
      </Row>
      <Row>
        <Col>
          <nav className='ms-3'>
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to={"/"} className='text-decoration-none text-black'>Chennai Auction Property</Link></li>
              <li className="breadcrumb-item active">IndividualVilla</li>
            </ol>
          </nav>
        </Col>
     
        <Col md={6}  className='text-end'>
          <button onClick={toggleViewType} className="btn btn-primary mb-3 viewbutton">
            {viewType === 'grid' ? 'Switch to Grid View' : 'Switch to List View'}
          </button>
        </Col>
      </Row>
      <Row className=''>
        <Col md={viewType === 'grid' ? 8 : 8}>
          <div className={viewType === 'grid' ? 'grid-view' : 'list-view'}>
            {currentProperties.map((property, index) => (
              <div className={`card-container1 mt-5 mb-5 ${viewType}` } key={index}>
                <div className="card-header1">
                  <img src={property.propertyImages[0].propertyImage} alt="card-image" className="card-image1" />
                </div>
                <div className="card-body1 m-2">
                  <h4 className="card-subtitle1">{property.propertyTitle}</h4>
                  <h6 className="card-title1">
                    <span className='text-capitalize' style={{fontSize: "12px", fontWeight:"200px"}}><i className="fa-solid fa-location-dot"></i> {property.address}</span>
                  </h6>
                  <table className="table table-striped-columns border border-2">
                    <thead>
                      <tr className='bg-color-2'>
                        <th className='text-center fw-medium'>Type</th>
                        <th className='text-center fw-medium'>Property Type</th>
                        <th className='text-center fw-medium'>Price</th>
                        <th className='text-center fw-medium'>Sqft</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className='bg-color-1'>
                        <td className='text-center fw-light'>{property.type}</td>
                        <td className='text-center fw-light'>{property.propertyType}</td>
                        <td className='text-center fw-light'>{formatPrice(property.price)}</td>
                        <td className='text-center fw-light'>{property.totalArea}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className={`card-text1 ${expandedDescriptions[index] ? 'expanded' : 'collapsed'}`} onClick={() => toggleDescription(index)} style={{ cursor: 'pointer' }}>
                    <span className='fw-bold text-capitalize'>{property.title}</span>
                    <div dangerouslySetInnerHTML={{ __html: expandedDescriptions[index] ? property.propertyDescription : `${property.propertyDescription.slice(0, 100)}...` }} />
                    {/* <span style={{ color: 'blue', marginLeft: '0px' }} className='fw-bold text-black'>
                      {expandedDescriptions[index] ? 'Show Less' : 'Show More'} */}
                    {/* </span> */}
                  </div>
                  <div className='d-flex mt-3'>
                    <Link to={`/viewalldetails/${property._id}`} className='ms-auto'>
                      <button className='btn btn-warning opacity-75 fw-bold text-white'>More Details</button>
                    </Link>
                    <button className='btn btn-outline-dark ms-2 fw-bold' onClick={() => setModalShow(true)}>Enquiry</button>
                    <EnquiryFormModal show={modalShow} onHide={() => setModalShow(false)} />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="d-flex justify-content-center mt-4">
            <nav>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button onClick={prevPage} className="page-link">Previous</button>
                </li>
                {[...Array(totalPages).keys()].map((number) => (
                  <li key={number} className={`page-item ${currentPage === number + 1 ? 'active' : ''}`}>
                    <button onClick={() => paginate(number + 1)} className="page-link">
                      {number + 1}
                    </button>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button onClick={nextPage} className="page-link">Next</button>
                </li>
              </ul>
            </nav>
          </div>
        </Col>
        <Col md={viewType === 'grid' ? 4 : 4} className='propertyfilter'>
          <PropertyFilter onFilter={handleFilter} />
        </Col>
      </Row>
    </div>
  );
}

export default IndividualVilla;
